import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from '@as/cotopaxi';
import { BasketButtonError } from '@as-react/common-types';
import { EnvelopeSimpleIcon, InfoIcon } from '@yonderland/andes-icons';
import { Box, Chip, Icon, StackBlock, StackInline, TextAlpha, useBreakpoints } from '@yonderland/andes-react';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { PRODUCT_SIZE_CHIP_INNER_PADDING } from '../../../constants/ProductConstants';
import { getActiveSizeOptions, getSizeButtonsError, splitSizesBySizeAndLength } from '../../../util/ProductUtil';
import { ScrollUtil } from '../../../util/ScrollUtil';
export const SizeSelectButtonsSplitted = ({ type, id, selectedOption, setSelectedOption, lengthOptions, setLengthOptions, setSizeOptions, sizeOptions, isNotifyMeSizeError, options, filteredSizes, basketValidationState, selectedColorId, setFirstSelectedType, firstSelectedType, sizeCombinationNotExist, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { isLg, isXl, is2xl } = useBreakpoints();
    const isDesktop = isLg || isXl || is2xl;
    const { sizesMap, lengthsMap } = splitSizesBySizeAndLength(filteredSizes);
    const [errorMessage, setErrorMessage] = useState();
    const isSize = type === 'size';
    const typeMap = isSize ? sizesMap : lengthsMap;
    const typeOptions = isSize ? sizeOptions : lengthOptions;
    const withNotifyMe = typeOptions.some(option => option.isNotifyMe);
    const chipSize = `${Math.max(...[...typeMap.keys()].map(s => s.length)) + (withNotifyMe ? 4 : 2)}ch + ${PRODUCT_SIZE_CHIP_INNER_PADDING + (withNotifyMe ? 6 : 0)}px`;
    const getSizeButtonState = (option, selected) => {
        if (option.disabled) {
            return 'disabled';
        }
        if (errorMessage &&
            !option.disabled &&
            (!option.isNotifyMe || (!option.isSoldOut && isNotifyMeSizeError)) &&
            !selectedOption) {
            return 'error';
        }
        if (option.label === selected) {
            return 'activated';
        }
        return 'resting';
    };
    const handleButtonClick = (option) => () => {
        if (option.disabled)
            return;
        setErrorMessage(undefined);
        setSelectedOption(option.label.toString());
        if (!firstSelectedType) {
            setFirstSelectedType(type);
        }
        const updatedOptions = getActiveSizeOptions(typeMap.get(option.label.toString()) || [], options, isSize ? lengthOptions : sizeOptions, isSize ? 'length' : 'size');
        if (isSize) {
            setLengthOptions(updatedOptions);
        }
        else {
            setSizeOptions(updatedOptions);
        }
    };
    useEffect(() => {
        setErrorMessage(undefined);
    }, [selectedColorId]);
    useEffect(() => {
        if ((basketValidationState === BasketButtonError.SKU_OPEN_SIZE_SELECT ||
            basketValidationState === BasketButtonError.SKU ||
            isNotifyMeSizeError) &&
            !selectedOption) {
            ScrollUtil.scrollToErrorElement(document.getElementById(id), isDesktop, () => setErrorMessage(getSizeButtonsError(basketValidationState, type)));
        }
    }, [basketValidationState, selectedOption, isNotifyMeSizeError, sizeCombinationNotExist]);
    const buttonOptions = useMemo(() => typeOptions.map(option => (_jsx(Chip, { state: getSizeButtonState(option, selectedOption), iconLeft: option.isNotifyMe && type !== firstSelectedType ? { source: EnvelopeSimpleIcon } : undefined, text: option.label, strikethrough: type !== firstSelectedType && ((option.isSoldOut && option.isNotifyMe) || option.disabled), onClick: option.disabled ? undefined : handleButtonClick(option), size: "md", variant: "primary" }, option.label))), [options, sizeOptions, lengthOptions, errorMessage]);
    return (_jsxs(StackBlock, { id: id, testId: id, gap: "2", children: [_jsx(TextAlpha, { strong: true, children: t(`pdp.size.buttons.${type}`) }), _jsx(Grid, { scalable: {
                    min: `calc(${chipSize})`,
                    maxCols: typeOptions.length <= 2 ? { mobile: 2, desktop: 3 } : { mobile: 4, desktop: 6 },
                    repeatPattern: typeOptions.length <= 2 ? 'auto-fill' : undefined,
                }, gap: "s", dataQA: `${type}-select-buttons`, children: buttonOptions }), errorMessage && (_jsxs(StackInline, { gap: "1", wrap: "nowrap", children: [_jsx(Box, { paddingBlockStart: "1", children: _jsx(Icon, { source: InfoIcon, color: "error", size: "xs" }) }), _jsx(TextAlpha, { color: "error", children: t(errorMessage) })] }))] }));
};
